import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "text-base mt-14 w-full 2xl:w-[50%] mx-auto" }
const _hoisted_2 = { class: "font-semibold text-3xl text-gray-900" }
const _hoisted_3 = { class: "text-gray-600 font-normal text-base" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col items-center mt-8"
}
const _hoisted_5 = { class: "font-semibold text-sm" }
const _hoisted_6 = { class: "flex flex-col bg-white rounded-3xl border border-gray-200 p-6" }
const _hoisted_7 = { class: "flex flex-col gap-3" }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "mx-2 w-1/3" }
const _hoisted_10 = {
  for: "first_name",
  class: "block mb-2 text-sm font-medium text-gray-700"
}
const _hoisted_11 = { class: "border border-gray-300 rounded-md flex p-[2px]" }
const _hoisted_12 = { class: "ml-[2px] border-none focus:outline-none focus:ring-0 focus:border-transparent" }
const _hoisted_13 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_14 = { class: "mx-2 w-1/3" }
const _hoisted_15 = {
  for: "last_name",
  class: "block mb-2 text-sm font-medium text-gray-700"
}
const _hoisted_16 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_17 = { class: "mx-2 w-1/3" }
const _hoisted_18 = {
  for: "title",
  class: "block mb-2 text-sm font-medium text-gray-700"
}
const _hoisted_19 = ["placeholder", "onUpdate:modelValue"]
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "mx-2 w-[32%]" }
const _hoisted_22 = {
  for: "email",
  class: "block mb-2 text-sm font-medium text-gray-700"
}
const _hoisted_23 = { class: "border border-gray-300 rounded-md flex p-[2px] items-center" }
const _hoisted_24 = { class: "ml-[6px] h-5 w-5 shrink-0 text-gray-400 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = {
  key: 0,
  class: "text-sm font-medium text-gray-700 mt-2"
}
const _hoisted_27 = { class: "mx-2 w-[32%]" }
const _hoisted_28 = {
  for: "phone",
  class: "block mb-2 text-sm font-medium text-gray-700"
}
const _hoisted_29 = { class: "border border-gray-300 rounded-md flex p-[2px]" }
const _hoisted_30 = { class: "ml-[2px] border-none focus:outline-none focus:ring-0 focus:border-transparent" }
const _hoisted_31 = ["onUpdate:modelValue"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "h-8 w-8 text-pink-400 shrink-0 [&>svg]:h-8 [&>svg]:w-8" }
const _hoisted_34 = { class: "h-5 w-5 shrink-0 text-gray-600 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_35 = { class: "font-semibold text-sm" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "font-semibold text-sm" }

import { NewClassTeacher } from '@/interfaces/school-structure.interface';
import { useFilterStore } from '@/stores/filterStore';
import { useSchoolStore } from '@/stores/schoolStore';
import { computed, onMounted, ref, watch } from 'vue';
import { generateUniqueUID } from '@/modules/main/components/constants/defaults';

type SchoolStoreType = ReturnType<typeof useSchoolStore>;
type FilterStoreType = ReturnType<typeof useFilterStore>;


export default /*#__PURE__*/_defineComponent({
  __name: 'AddTeachersComponent',
  props: {
    step: {},
    teachersArray: {},
    schoolStore: {},
    filterStore: {}
  },
  emits: ["update:teachers", "nextStep"],
  setup(__props: any, { emit }) {

const props = __props;

const teacherEmailsApiStatus = ref<any>({});
const teachers = ref<NewClassTeacher[]>([]);





// Add teacher function
const addTeacher = () => {
  teachers.value.push({
    tempId: generateUniqueUID(),
    firstName: "",
    lastName: "",
    email: "",
    designation: "Class Teacher",
    phoneNumber: "",
    classes: [],
    status: "inactive",
    school: props.filterStore.selectedFilters.school
  });
};

// Function to check if the email already exists in the teachers array
const checkEmailExists = (email: string, index: number) => {
  return teachers.value.some(
    (teacher, i) => i !== index && teacher.email === email
  );
};

// Computed property to validate email for a specific teacher
const emailValidation = (teacherEmail: string, index: number) => {
  return computed(() => {
    // Only check if there's more than one teacher and the email is not empty
    if (teachers.value.length > 1 && teacherEmail.trim() !== "") {
      return checkEmailExists(teacherEmail, index);
    }
    // No validation error by default
    return false;
  });
};

// Function to check email registration with API (async)
const emailAlreadyRegistered = async (email: any, index: any) => {
  const result = await props.schoolStore?.validateEmail(email);
  teacherEmailsApiStatus.value[index] = result; // Save the result per teacher's index
};

// Trigger the API email validation check when email changes
const validateTeacherEmail = (email: any, index: any) => {
  emailAlreadyRegistered(email, index); // Call API validation
};

const isButtonDisabled = computed(() => {
  if (teachers.value.length === 0) return false;

  return teachers.value.some((teacher, index) => {
    // Check if all the fields are filled
    if (
      teacher.firstName === "" ||
      teacher.lastName === "" ||
      teacher.email === "" ||
      teacher.phoneNumber === ""
    ) {
      return true;
    }

    return (
      emailValidation(teacher.email, index).value ||
      teacherEmailsApiStatus.value[index] === true
    );
  });
});

// Watch each teacher's email and validate it using the API
watch(
  teachers,
  (newTeachers) => {
    newTeachers.forEach((teacher, index) => {
      if (teacher.email.trim() !== "") {
        // Validate with API on email change
        validateTeacherEmail(teacher.email, index);
      }
    });
    // Deep watch to track changes inside the teachers array
  },
  { deep: true }
);

const deleteTeacher = (index: number) => {
  teachers.value.splice(index, 1);
};

const handleNext = () => {
  emit('nextStep');
  emit('update:teachers', teachers.value);
};

onMounted(() => {
  teachers.value = props.teachersArray;
});

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.title")), 1),
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.subtitle")), 1),
      (teachers.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass('px-[14px] py-[10px] text-white bg-blue-600 border border-blue-600 rounded-lg '
            ),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (addTeacher()))
            }, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add_a_teacher")), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachers.value, (teacher, index) => {
      return (_openBlock(), _createElementBlock("form", {
        class: "pt-6",
        key: index
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.name")), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("select", _hoisted_12, [
                    _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.mr")), 1),
                    _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.ms")), 1),
                    _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.mrs")), 1),
                    _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.dr")), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "first_name",
                    class: "bg-white mr-[3px] border-none focus:outline-none focus:ring-0 focus:border-transparent text-gray-500 text-base block w-full p-2.5",
                    placeholder: _ctx.$t('add_grades_class_component.step_1.name'),
                    "onUpdate:modelValue": ($event: any) => ((teacher.firstName) = $event),
                    required: ""
                  }, null, 8, _hoisted_13), [
                    [_vModelText, teacher.firstName]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.surname")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "last_name",
                  class: "bg-white text-gray-500 text-base rounded-lg border border-gray-300 block w-full p-2.5",
                  placeholder: _ctx.$t('add_grades_class_component.step_1.surname'),
                  "onUpdate:modelValue": ($event: any) => ((teacher.lastName) = $event),
                  required: ""
                }, null, 8, _hoisted_16), [
                  [_vModelText, teacher.lastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.position")), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "title",
                  readonly: "",
                  class: "bg-slate-300 cursor-not-allowed text-gray-500 text-base rounded-lg border border-gray-300 block w-full p-2.5",
                  placeholder: _ctx.$t('add_grades_class_component.step_1.position'),
                  "onUpdate:modelValue": ($event: any) => ((teacher.designation) = $event),
                  required: ""
                }, null, 8, _hoisted_19), [
                  [_vModelText, teacher.designation]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.email")), 1),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, [
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-email',
                      title: 'rl email',
                      "aria-hidden": "true"
                    })
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "email",
                    class: "bg-white mr-[3px] border-none focus:outline-none focus:ring-0 focus:border-transparent text-gray-500 text-base block w-full p-2.5",
                    placeholder: "leah@reflective.co.za",
                    "onUpdate:modelValue": ($event: any) => ((teacher.email) = $event),
                    required: ""
                  }, null, 8, _hoisted_25), [
                    [_vModelText, teacher.email]
                  ])
                ]),
                (
                    (emailValidation(teacher.email, index).value && index) ||
                    teacherEmailsApiStatus.value[index] === true
                )
                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.email_exists")), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.phone_number")), 1),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("select", _hoisted_30, [
                    _createElementVNode("option", null, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.sa")), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    id: "phone",
                    class: "bg-white mr-[3px] border-none focus:outline-none focus:ring-0 focus:border-transparent text-gray-500 text-base block w-full p-2.5",
                    placeholder: "+27 (0) 000-0000",
                    "onUpdate:modelValue": ($event: any) => ((teacher.phoneNumber) = $event),
                    required: ""
                  }, null, 8, _hoisted_31), [
                    [_vModelText, teacher.phoneNumber]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "hidden lg:flex ml-auto mt-5",
            onClick: ($event: any) => (deleteTeacher(index))
          }, [
            _createElementVNode("span", _hoisted_33, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-trash',
                title: 'rl trash',
                "aria-hidden": "true"
              })
            ])
          ], 8, _hoisted_32)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", {
      class: _normalizeClass('flex items-center mt-6 ' + (teachers.value.length > 0 ? 'justify-between' : 'justify-end'))
    }, [
      (teachers.value.length > 0)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "flex gap-[6px] items-center px-4 p-2 rounded-[1.25rem] justify-center text-gray-600",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addTeacher()))
          }, [
            _createElementVNode("span", _hoisted_34, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-plus',
                title: 'rl plus',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("h1", _hoisted_35, _toDisplayString(_ctx.$t("add_grades_class_component.step_1.btn_add")), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        disabled: isButtonDisabled.value,
        class: _normalizeClass('px-[14px] py-[10px] text-white bg-blue-600 border border-blue-600 rounded-lg ' +
            (isButtonDisabled.value ? 'cursor-not-allowed' : 'cursor-pointer')
            ),
        onClick: handleNext
      }, [
        _createElementVNode("h1", _hoisted_37, _toDisplayString(_ctx.$t("add_grades_class_component.btn_next")) + " " + _toDisplayString(_ctx.step + 1), 1)
      ], 10, _hoisted_36)
    ], 2)
  ]))
}
}

})